module.exports = __webpack_public_path__ + "static/sample-flyer-front-3f86e671c8ebde3f84b69d7033be4c0f.webp";